// Top
export async function randomize() {
    // Yellow, Green, Blue
    let colourArray = ['yellow', 'yellow', 'blue', 'blue', 'green', 'green']

    let index = 0;
    // Surplus Area Randomize 
    let surplusArea = Math.floor(Math.random() * 3 + 1);

    // Identifier Randomize
    switch (surplusArea) {
        case 1: {
            // console.log('Solar Surplus');
            index = colourArray.findIndex(element => element === "yellow");
            colourArray[index] = 'black';
            break;
        }
        case 2: {
            // console.log('Wind Surplus');
            index = colourArray.findIndex(element => element === "green");
            colourArray[index] = 'black';
            break;
        }
        case 3: {
            // console.log('Water Surplus');
            index = colourArray.findIndex(element => element === "blue");
            colourArray[index] = 'black';
            break;
        }
    }
    colourArray = colourArray.sort(() => Math.random() - 0.5);


    // Output
    console.log("-----------------------------");
    console.log("Surplus Area: " + ((surplusArea === 1) ? 'Solar Energy' : (surplusArea === 2) ? 'Wind Energy' : 'Water Energy'));
    console.log("-----------------------------");
    // Top 
    console.log("Top: " + colourArray[0] + " | " + colourArray[1]);
    // Bottom Left
    console.log("Bottom Left: " + colourArray[2] + " | " + colourArray[3]);
    // Bottom Right
    console.log("Bottom Right: " + colourArray[4] + " | " + colourArray[5]);
    console.log("-----------------------------");

    let result = {
        "surplusArea": surplusArea, // 1,2,3
        "top1": colourArray[0],
        "top2": colourArray[1],
        "bottomLeft1": colourArray[2],
        "bottomLeft2": colourArray[3],
        "bottomRight1": colourArray[4],
        "bottomRight2": colourArray[5],
    };
    return result;
}